import { createContext } from 'react';

const PDPContext = createContext({});

export default PDPContext;
